'use client';

import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import AuthContent from './components/AuthContent';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export default function SignUpLoginPage() {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!loading && user) {
      const role = user?.user_metadata?.role || 'tenant';
      if (role === 'admin') {
        router?.replace('/admin');
      } else if (role === 'owner') {
        router?.replace('/owner-dashboard');
      } else {
        router?.replace('/');
      }
    }
  }, [user, loading, router]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 size={32} className="animate-spin text-primary" />
      </div>
    );
  }

  if (user) return null;

  return <AuthContent />;
}